(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jollyriot-inspiration-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('jr-inspiration-hero')) {
  customElements.define('jr-inspiration-hero', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => this.init(), { once: true, signal: this.abort.signal });
      else this.init();
    }
    init() {
      if (this.initialized || !this.isConnected) return;
      this.initialized = true;
      this.slides = Array.from(this.querySelectorAll('.jrh-slide'));
      this.current = 0;
      this.classList.add('is-ready');
      if (this.slides.length < 2) return;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = false;
      this.hovered = false;
      this.focused = false;
      this.visible = true;
      this.pauseButton = this.querySelector('[data-pause]');
      const listen = (target, type, callback) => target?.addEventListener(type, callback, { signal: this.abort.signal });
      listen(this.querySelector('[data-prev]'), 'click', () => this.manual(this.current - 1));
      listen(this.querySelector('[data-next]'), 'click', () => this.manual(this.current + 1));
      listen(this.pauseButton, 'click', () => { this.paused = !this.paused; this.updatePause(); this.schedule(); });
      listen(this.querySelector('.jrh-media'), 'keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); this.manual(this.current + (event.key === 'ArrowLeft' ? -1 : 1)); }
      });
      listen(this, 'pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.schedule(); } });
      listen(this, 'pointerleave', () => { this.hovered = false; this.schedule(); });
      listen(this, 'focusin', () => { this.focused = true; this.schedule(); });
      listen(this, 'focusout', event => { this.focused = this.contains(event.relatedTarget); this.schedule(); });
      listen(document, 'visibilitychange', () => this.schedule());
      listen(this.motion, 'change', () => { this.updatePause(); this.schedule(); });
      listen(document, 'shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
        if (index >= 0) this.manual(index);
      });
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.schedule(); }, { threshold: .15 });
      this.observer.observe(this);
      this.updatePause();
      this.schedule();
    }
    show(index, announce = false) {
      this.current = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { slide.classList.toggle('is-active', i === this.current); slide.setAttribute('aria-hidden', String(i !== this.current)); });
      this.querySelector('[data-current]').textContent = String(this.current + 1);
      if (announce) this.querySelector('[data-status]').textContent = 'Photo ' + (this.current + 1) + ' of ' + this.slides.length + ': ' + (this.slides[this.current].querySelector('figcaption')?.textContent || '');
    }
    manual(index) { this.paused = true; this.show(index, true); this.updatePause(); this.schedule(); }
    updatePause() {
      if (!this.pauseButton) return;
      this.pauseButton.hidden = this.motion.matches || this.dataset.editor === 'true';
      this.pauseButton.setAttribute('aria-label', this.paused ? 'Play slideshow' : 'Pause slideshow');
      this.pauseButton.querySelector('[data-pause-icon]').textContent = this.paused ? '▶' : 'Ⅱ';
      this.pauseButton.querySelector('[data-pause-text]').textContent = this.paused ? 'Play' : 'Pause';
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.dataset.autoplay !== 'true' || this.dataset.editor === 'true' || this.paused || this.hovered || this.focused || !this.visible || document.hidden || this.motion.matches) return;
      this.timer = setTimeout(() => { this.show(this.current + 1); this.schedule(); }, Number(this.dataset.interval) || 6000);
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); clearTimeout(this.timer); this.initialized = false; }
  });
}

  } catch(e) { console.error(e); }
})();
})();
